import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FormCheck',
    props: {
        value: null,
        options: null
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        const currentValue = computed({
            get: () => {
                const val = props.value ?? [];
                return Array.isArray(val) ? val : [val];
            },
            set: (newValue) => {
                if (newValue.length > 0) {
                    emit("input", newValue);
                }
                else {
                    emit("input", null);
                }
            },
        });
        const hasOptions = computed(() => props.options.length > 0);
        const indeterminate = computed(() => ![0, props.options.length].includes(currentValue.value.length));
        const selectAll = computed(() => currentValue.value.length === props.options.length);
        function onSelectAll(selected) {
            if (selected) {
                const allValues = props.options.map((option) => option.value);
                emit("input", allValues);
            }
            else {
                emit("input", null);
            }
        }
        return { __sfc: true, props, emit, currentValue, hasOptions, indeterminate, selectAll, onSelectAll };
    }
});
